import React, {useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useHtmlClassService} from "../../_core/MetronicLayout";
import Topbar from "./Topbar";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {SearchBar} from "./partials/SearchBar";
import CollapsedMenu from "./CollapsedMenu";
import LanguageDropdown from "./LanguageDropdown";

//redux:
import {showSearchBar} from "../../../../app/redux/Layout/layoutSlice";
import {queryActions} from "../../../../app/redux/Query/queryRedux";
import {loadParameter} from "../../../../app/redux_slices/contextSlice";

export function Header(props) {
    const {params} = props;

    const uiService = useHtmlClassService();

    //redux:
    const dispatch = useDispatch();
    const clearSearcher = () => dispatch(queryActions.clearSearcher());
    const corporativeLogo = useSelector(state => loadParameter(state, "corporativeLogo"));
    const _showSearchBar = useSelector(showSearchBar);
    const showSearchResults = useSelector(state => state.query.showResults);

    const isHome = useSelector(state => state.layout.isHome)

    const layoutProps = useMemo(() => {
        return {
            headerClasses: uiService.getClasses("header", true),
            headerAttributes: uiService.getAttributes("header"),
            headerContainerClasses: uiService.getClasses("header_container", true),
        };
    }, [uiService]);

    return (
        <div className="position-absolute w-100">
            <div
                className={`header ${layoutProps.headerClasses} position-relative`}
                style={{
                    color: "white",
                    background: "transparent",
                }}
                id="kt_header"
                {...layoutProps.headerAttributes}
            >
                <div
                    className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
                >
                    <div className="header-logo_img">
                        <a
                            href={"/homepage"}
                            onClick={() => {
                                if (showSearchResults) clearSearcher();
                            }}
                        >
                            <img src={corporativeLogo || "/media/logos/winnow-white.png"} alt="logo"/>
                        </a>
                        <HeaderMenuWrapper/>
                    </div>

                    {/* SEARCHBAR: */}
                    {_showSearchBar ? <SearchBar params={params}/> : null}

                    {/* right buttons desktop: */}
                    <div id={'tour-profile'} className="d-flex align-items-center">
                        <Topbar/>
                        <LanguageDropdown/>
                        <CollapsedMenu/>
                    </div>
                </div>
            </div>
        </div>
    );
}
